module.exports = __webpack_public_path__ + "static/img/banner-invite-en.273dbacc.png";